import { useEffect } from "react";

import VenueAndTaskAndUser from "@/services/common/search/venueAndTaskAndUser";

import type { VenueAndTaskAndUserResponse } from "@/components/shared/venueAndTaskAndUserSearch";
import type { SelectedSearchResult } from "@/states/common/venueAndTaskAndUserSearch/selectedSearchResultAtom";
import { ApplyFilter } from "@/types/owner/task/applyFilter";

type Props = {
  word: string;
  typing: boolean;
  firstSearch: boolean;
  resultSelected: boolean;
  searchType: "contract" | "venue";
  user: string;
  token: any;
  searched: boolean;
  filterList: any;
  setSearchLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setSearchVenues: React.Dispatch<
    React.SetStateAction<VenueAndTaskAndUserResponse[]>
  >;
  setShowList: React.Dispatch<React.SetStateAction<boolean>>;
  setResultSelected: React.Dispatch<React.SetStateAction<boolean>>;
  setSearched: React.Dispatch<React.SetStateAction<boolean>>;
  setSearchWord: React.Dispatch<React.SetStateAction<SelectedSearchResult>>;
  setContractSearchWord: React.Dispatch<
    React.SetStateAction<SelectedSearchResult>
  >;
  setFilterList?: React.Dispatch<React.SetStateAction<any>>;
  setApplyFilter?: React.Dispatch<React.SetStateAction<ApplyFilter>>;
};

//検索ワードが変更されたら検索実行
export const useVenueAndTaskAndUserSearch = ({
  word,
  typing,
  firstSearch,
  resultSelected,
  searchType,
  user,
  token,
  searched,
  filterList,
  setSearchLoading,
  setSearchVenues,
  setShowList,
  setResultSelected,
  setSearched,
  setSearchWord,
  setContractSearchWord,
  setFilterList,
  setApplyFilter
}: Props) => {
  useEffect(() => {
    (async () => {
      if (word && !typing) {
        try {
          setSearchLoading(true);
          //物件名と住所で検索
          const vt = new VenueAndTaskAndUser(user);
          const vtRes = await vt.keywordSearch(word, token, filterList);
          setSearchVenues(vtRes || []);

          //検索結果リストの表示
          if (firstSearch && !resultSelected) {
            setShowList(true);
          }
        } catch (e) {
          console.error(e);
        } finally {
          setResultSelected(false);
          setSearchLoading(false);
        }
      } else if (searched) {
        if (setFilterList) {
          setFilterList({
            ...filterList,
            page: 1,
            venueId: [],
            cat_search: 0,
            q: "",
            equal: 0
          });
        }
        setShowList(false);
        setSearched(false);
        const searchWordArr = {
          word: word,
          activeType: ""
        };
        if (searchType === "venue") {
          setSearchWord(searchWordArr);
        } else {
          setContractSearchWord(searchWordArr);
        }
        if (setApplyFilter) setApplyFilter("normal");
      }
      return () => {
        setShowList(false);
        setSearched(false);
        setSearchVenues([]);
      };
    })();
  }, [word, typing]);
};
